export const waitForKlaviyo = () => {
    if (window.klaviyo) {
        return Promise.resolve(null);
    }

    return new Promise((resolve) => {
        const interval = setInterval(() => {
            if (window.klaviyo) {
                clearInterval(interval);
                clearTimeout(timeout);
                resolve(null);
            }
        }, 500);

        const timeout = setTimeout(() => {
            clearInterval(interval);
            resolve(null);
        }, 30_000);
    });
};